import { startBookletTool } from "./booklet-tool.js";
import { startLookalikeWorksheetTool } from "./lookalike-tool.js";
import { startPinyinWorksheetTool } from "./pinyin-worksheet-tool.js";
import { startSentenceWorksheetTool } from "./sentence-tool.js";
import { startTools } from "./start-tools.js";
import { startStructureWorksheetTool } from "./structure-tool.js";
import { startVocabularyWorksheetTool } from "./vocabulary-tool.js";
import { startWorksheetTool } from "./worksheet-tool.js";

/**
 * The bundle for the worksheet generators: the character, pinyin, look-alike,
 * vocabulary, structure and sentence sheets.
 *
 * A bundle of its own, like every tool's: it draws stroke outlines and reads
 * 词典 entries, and none of the converters' linguistics. The sheets share
 * nearly all of it, so they share the bundle too.
 */
startTools(
  document,
  new Map([
    ["worksheet", startWorksheetTool],
    ["pinyin-worksheet", startPinyinWorksheetTool],
    ["lookalike-worksheet", startLookalikeWorksheetTool],
    ["vocabulary-worksheet", startVocabularyWorksheetTool],
    ["structure-worksheet", startStructureWorksheetTool],
    ["sentence-worksheet", startSentenceWorksheetTool],
    ["revision-booklet", startBookletTool],
  ]),
);
